import {AppDate} from "../utils/date-utils/AppDate.ts";
import {User} from "@models/user.model.ts";


export class Trace {
  id: number;
  create_date: AppDate;
  status: string;
  feature: string;
  action: string;
  http_method: string;
  http_status: number;
  url: string;
  duration: number;
  user: User;
  messages: string[];
  request: object;
  response: object;
  query_params: object;

  constructor() {
    this.id = -1;
    this.create_date = new AppDate();
    this.status = '';
    this.feature = '';
    this.action = '';
    this.http_method = '';
    this.http_status = 0;
    this.url = '';
    this.duration = 0;
    this.user = new User();
    this.messages = [];
    this.request = {};
    this.response = {};
    this.query_params = {};

  }
}


